<template>
  <a-card :bordered="false">
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!--<a-button @click="handleAdd" type="primary" icon="plus">{{ $t('button.add') }}</a-button>-->
      <mtc-button @click="handleAdd" type="primary" icon="plus" text="button.add"></mtc-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('分类字典')">{{ $t('button.export') }}</a-button>-->
      <mtc-button @click="handleExportXls('分类字典')" type="primary" icon="download" text="button.export"></mtc-button>
      <a-upload name="file"
                :showUploadList="false"
                :multiple="false"
                :headers="tokenHeader"
                :action="importExcelUrl"
                @change="handleImportExcel">
        <!--<a-button type="primary" icon="import">{{ $t('button.import') }}</a-button>-->
        <mtc-button type="primary" icon="import" text="button.import"></mtc-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            {{ $t('button.delete') }}
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('button.batchOperation') }}
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>
    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        {{ $t('tip.selected') }}
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
        {{ $t('tip.term') }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('button.clear') }}</a>
      </div>
      <a-table ref="table"
               size="middle"
               rowKey="id"
               :columns="columns"
               :dataSource="dataSource"
               :pagination="ipagination"
               :loading="loading"
               :expandedRowKeys="expandedRowKeys"
               @change="handleTableChange"
               @expand="handleExpand"
               v-bind="tableProps">
        <template v-for="(item, index) in columns" :slot="item.slotName">
          <!--<span :key="index">{{ $t(item.slotName) }}</span>-->
          <mtcHeader :key="index" :text="item.slotName" />
        </template>
        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>
        <span slot="action" slot-scope="text, record">
          <!--<a @click="handleEdit(record)">{{ $t('button.edit') }}</a>-->
          <mtc-button @click="handleEdit(record)" type="link" size="small" text="button.edit"></mtc-button>
          <a-divider type="vertical" />
          <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record)">
            <!--<a>{{ $t('button.delete') }}</a>-->
             <mtc-button type="link" size="small" text="button.delete"></mtc-button>
          </a-popconfirm>
          <a-divider type="vertical" />
          <!--<a @click="handleAddSub(record)">添加下级</a>-->
          <mtc-button @click="handleAddSub(record)" type="link" size="small" text="button.addSubordinate"></mtc-button>
        </span>
      </a-table>
    </div>
    <sysCategory-modal ref="modalForm" @ok="modalFormOk"></sysCategory-modal>
  </a-card>
</template>

<script>
import { getAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import SysCategoryModal from './modules/SysCategoryModal'
import { deleteAction } from '@/api/manage'
import { MTC_AUTH } from '@api/servers'

export default {
  name: 'SysCategoryList',
  mixins: [JeecgListMixin],
  components: {
    SysCategoryModal
  },
  data() {
    return {
      description: '分类字典管理页面',
      // 表头
      columns: [
        {
          slotName: 'tableHeader.categoryName',
          // title: '分类名称',
          align: 'left',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name', title: 'tableHeader.categoryName' }
        },
        {
          slotName: 'tableHeader.categoryCode',
          // title: '分类编码',
          align: 'left',
          dataIndex: 'code',
          scopedSlots: { title: 'tableHeader.categoryCode' }
        },
        {
          slotName: 'tableHeader.operation',
          // title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 200,
          scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
        }
      ],
      url: {
        list: `${MTC_AUTH}sys/category/rootList`,
        childList: `${MTC_AUTH}sys/category/childList`,
        getChildListBatch: `${MTC_AUTH}sys/category/getChildListBatch`,
        delete: `${MTC_AUTH}sys/category/delete`,
        deleteBatch: `${MTC_AUTH}sys/category/deleteBatch`,
        exportXlsUrl: `${MTC_AUTH}sys/category/exportXls`,
        importExcelUrl: `${MTC_AUTH}sys/category/importExcel`
      },
      expandedRowKeys: [],
      hasChildrenField: 'hasChild',
      pidField: 'pid',
      dictOptions: {},
      subExpandedKeys: []
    }
  },
  computed: {
    importExcelUrl() {
      return `${window._CONFIG[ 'domianURL' ]}/${this.url.importExcelUrl}`
    },
    tableProps() {
      let _this = this
      return {
        // 列表项是否可选择
        rowSelection: {
          selectedRowKeys: _this.selectedRowKeys,
          onChange: (selectedRowKeys) => (_this.selectedRowKeys = selectedRowKeys)
        }
      }
    }
  },
  methods: {
    handleEdit: function(record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = this.$t('button.edit')
      this.$refs.modalForm.disableSubmit = false
    },
    loadData(arg) {
      if (arg == 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      let params = this.getQueryParams()
      return new Promise((resolve) => {
        getAction(this.url.list, params)
          .then((res) => {
            if (res.success) {
              let result = res.result
              if (Number(result.total) > 0) {
                this.ipagination.total = Number(result.total)
                this.dataSource = this.getDataByResult(res.result.records)

                let languageList = res.languageList

                // 列表多语言
                if (languageList && languageList.length) {
                  console.log('%c [ languageList ]', 'font-size:13px; background:pink; color:#bf2c9f;', languageList)
                  this.dataSource.map(item => {
                    let secondLanguage = []
                    languageList.map(sItem => {
                      if (item.id == sItem.relBizId) {
                        if (sItem[ 'langType' ] == this.$ls.get('language', 'zh-cn')) {
                          item[ sItem[ 'relEntityAttribute' ] ] = sItem[ 'langText' ]
                        } else {
                          let secondLanguages = JSON.parse(this.$ls.get('secondLanguage')) || []
                          secondLanguages && secondLanguages.length && secondLanguages.map(ssItem => {
                            if (ssItem == sItem.langType) {
                              secondLanguage.push(sItem)
                            }
                          })
                        }
                      }
                    })
                    item[ 'secondLanguage' ] = secondLanguage
                    item[ 'sysLanguageList' ] = languageList
                  })
                }
                console.log('%c [ this.dataSource ]', 'font-size:13px; background:pink; color:#bf2c9f;', this.dataSource)
                //update--begin--autor:lvdandan-----date:20201204------for：JT-31 删除成功后默认展开已展开信息
                return this.loadDataByExpandedRows(this.dataSource)
                //update--end--autor:lvdandan-----date:20201204------for：JT-31 删除成功后默认展开已展开信息
              } else {
                this.ipagination.total = 0
                this.dataSource = []
              }
            } else {
              this.$message.warning(res.message)
            }
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    getDataByResult(result) {
      return result.map((item) => {
        //判断是否标记了带有子节点
        if (item[ this.hasChildrenField ] == '1') {
          let loadChild = { id: item.id + '_loadChild', name: 'loading...', isLoading: true }
          item.children = [loadChild]
        }
        return item
      })
    },
    handleExpand(expanded, record) {
      // 判断是否是展开状态
      if (expanded) {
        this.expandedRowKeys.push(record.id)
        if (record.children.length > 0 && record.children[ 0 ].isLoading === true) {
          let params = this.getQueryParams() //查询条件
          params[ this.pidField ] = record.id
          getAction(this.url.childList, params).then((res) => {
            if (res.success) {
              if (res.result && res.result.length > 0) {
                let languageList = res.languageList
                if (languageList && languageList.length) {
                  console.log('%c [ languageList ]', 'font-size:13px; background:pink; color:#bf2c9f;', languageList)
                  res.result.map(item => {
                    let secondLanguage = []
                    languageList.map(sItem => {
                      if (item.id == sItem.relBizId) {
                        if (sItem[ 'langType' ] == this.$ls.get('language', 'zh-cn')) {
                          item[ sItem[ 'relEntityAttribute' ] ] = sItem[ 'langText' ]
                        } else {
                          let secondLanguages = JSON.parse(this.$ls.get('secondLanguage')) || []
                          secondLanguages && secondLanguages.length && secondLanguages.map(ssItem => {
                            if (ssItem == sItem.langType) {
                              secondLanguage.push(sItem)
                            }
                          })
                        }
                      }
                    })
                    item[ 'secondLanguage' ] = secondLanguage
                    item[ 'sysLanguageList' ] = languageList
                  })
                }
                record.children = this.getDataByResult(res.result)
                this.dataSource = [...this.dataSource]
              } else {
                record.children = ''
                record.hasChildrenField = '0'
              }
            } else {
              this.$message.warning(res.message)
            }
          })
        }
      } else {
        let keyIndex = this.expandedRowKeys.indexOf(record.id)
        if (keyIndex >= 0) {
          this.expandedRowKeys.splice(keyIndex, 1)
        }
      }
    },
    initDictConfig() {
    },
    modalFormOk(formData, arr) {
      if (!formData.id) {
        this.addOk(formData, arr)
      } else {
        this.editOk(formData, this.dataSource)
        this.dataSource = [...this.dataSource]
      }
    },
    editOk(formData, arr) {
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[ i ].id == formData.id) {
            arr[ i ] = formData
            break
          } else {
            this.editOk(formData, arr[ i ].children)
          }
        }
      }
    },
    async addOk(formData, arr) {
      if (!formData[ this.pidField ]) {
        this.loadData()
      } else {
        this.expandedRowKeys = []
        console.log('22222', arr)
        for (let i of arr) {
          await this.expandTreeNode(i)
        }
      }
    },
    expandTreeNode(nodeId) {
      return new Promise((resolve, reject) => {
        this.getFormDataById(nodeId, this.dataSource)
        let row = this.parentFormData
        this.expandedRowKeys.push(nodeId)
        let params = this.getQueryParams() //查询条件
        params[ this.pidField ] = nodeId
        getAction(this.url.childList, params).then((res) => {
          console.log('11111', res)
          if (res.success) {
            if (res.result && res.result.length > 0) {
              row.children = this.getDataByResult(res.result)
              this.dataSource = [...this.dataSource]
              resolve()
            } else {
              row.children = ''
              row.hasChildrenField = '0'
              reject()
            }
          } else {
            reject()
          }
        })
      })
    },
    getFormDataById(id, arr) {
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[ i ].id == id) {
            this.parentFormData = arr[ i ]
          } else {
            this.getFormDataById(id, arr[ i ].children)
          }
        }
      }
    },
    handleAddSub(record) {
      this.subExpandedKeys = []
      this.getExpandKeysByPid(record.id, this.dataSource, this.dataSource)
      this.$refs.modalForm.subExpandedKeys = this.subExpandedKeys
      this.$refs.modalForm.title = '添加子分类'
      this.$refs.modalForm.edit({ pid: record.id })
      this.$refs.modalForm.disableSubmit = false
    },
    handleDelete: function(record) {
      let that = this
      deleteAction(that.url.delete, { id: record.id }).then((res) => {
        if (res.success) {
          //update--begin--autor:lvdandan-----date:20201204------for：JT-31 删除成功后默认展开已展开信息
          that.loadData()
          //update--end--autor:lvdandan-----date:20201204------for：JT-31 删除成功后默认展开已展开信息
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    // 添加子分类时获取所有父级id
    getExpandKeysByPid(pid, arr, all) {
      if (pid && arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[ i ].id == pid) {
            this.subExpandedKeys.push(arr[ i ].id)
            this.getExpandKeysByPid(arr[ i ][ 'pid' ], all, all)
          } else {
            this.getExpandKeysByPid(pid, arr[ i ].children, all)
          }
        }
      }
    },
    // 根据已展开的行查询数据（用于保存后刷新时异步加载子级的数据）
    loadDataByExpandedRows(dataList) {
      if (this.expandedRowKeys.length > 0) {
        return getAction(this.url.getChildListBatch, { parentIds: this.expandedRowKeys.join(',') }).then((res) => {
          if (res.success && res.result.records.length > 0) {
            //已展开的数据批量子节点
            let records = res.result.records
            const listMap = new Map()
            for (let item of records) {
              let pid = item[ this.pidField ]
              if (this.expandedRowKeys.join(',').includes(pid)) {
                let mapList = listMap.get(pid)
                if (mapList == null) {
                  mapList = []
                }
                mapList.push(item)
                listMap.set(pid, mapList)
              }
            }
            let childrenMap = listMap
            let fn = (list) => {
              if (list) {
                list.forEach((data) => {
                  if (this.expandedRowKeys.includes(data.id)) {
                    data.children = this.getDataByResult(childrenMap.get(data.id))
                    fn(data.children)
                  }
                })
              }
            }
            fn(dataList)
          }
        })
      } else {
        return Promise.resolve()
      }
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>